import Swal from 'sweetalert2'
import api from '../../models/receive'
import ReceiveDetailAddModal from '../../components/modal/receive_detail_add_modal'
import ReceiveDetailEditModal from '../../components/modal/receive_detail_edit_modal'
import ReceiveImportsModal from '../../components/modal/receive_imports_modal'
import SerialModal from '../../components/modal/receive_serial_modal'

export default {
  name: 'Receiveedit',
  components: {
    ReceiveDetailAddModal,
    ReceiveDetailEditModal,
    ReceiveImportsModal,
    SerialModal,
  },
  data() {
    return {
      search_text: '',
      modal_type: 0,
      per_page: 100,
      active_page: 1,
      isLoad: false,
      rec_id: '',
      spl_id: '',
      supplier: '',
      partstore: '',
      rec_note: '',
      data_edit: {},
      supplier_list: [],
      result_data: {
        pagination: [],
        count: 0,
      },
      modal_detail: {
        supplier: '',
        spl_id: 0,
        rec_id: 0,
        ps_id: '',
        recd_qty: '',
      },
      modal_edit_data: {},
      modal_scan_data: {
        recd_id: 0,
        ps_id: 0,
      },
      modal_receive_detail: {},
      str_data: '',
      code_data: '',
    }
  },
  methods: {
    backTopage() {
      this.$router.push({
        name: 'receive',
        query: this.$route.query,
      })
    },
    itemRender(current, type, originalElement) {
      if (type === 'prev') {
        return 'Previous'
      } else if (type === 'next') {
        return 'Next'
      }
      return originalElement
    },
    activePage(value) {
      this.active_page = value
      this.search()
    },
    search() {
      this.isLoad = true
      var obj = {
        page: this.active_page,
        limit: this.per_page,
        rec_id: this.rec_id,
        search: this.search_text,
      }
      this.result_data.pagination = []
      this.result_data.count = 0
      this.header.params = obj
      api.getReceiveDetail(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.result_data = result.data
          } else {
            this.alert_msg('warning', 'Receive Detail', result.message)
          }
          this.isLoad = false
        },
        (error) => {
          this.alert_msg('error', 'Receive Detail', error.message)
          this.isLoad = false
        }
      )
    },
    ExportReceive() {
      var obj = {
        rec_id: this.rec_id,
      }
      this.header.params = obj
      api.getReceiveDetailExport(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.str_data = JSON.stringify(result.data.pagination)
            this.code_data = this.data_edit.rec_code
            setTimeout(() => {
              this.$refs.ExportText.submit()
            }, 1000)
          } else {
            this.alert_msg('warning', 'Export Receive', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Export Receive', error.message)
        }
      )
    },
    checkForm() {
      var $myForm = $('#formEditReceive')
      if (!$myForm[0].checkValidity()) {
        $('#formEditReceive').addClass('was-validated')
      } else {
        this.editReceive()
      }
    },
    editReceive() {
      let formData = {
        rec_id: this.rec_id,
        rec_note: this.rec_note,
      }
      api.editReceive(
        this.$store.state.URLHost,
        formData,
        this.header,
        (result) => {
          if (result.response === true) {
            this.alert_msg('success', 'Update Receive', result.message)
          } else {
            this.alert_msg('warning', 'Update Receive', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Update Receive', error.message)
        }
      )
    },
    getReceiveByID() {
      var obj = {
        rec_id: this.rec_id,
      }
      this.header.params = obj
      api.getReceiveByID(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.data_edit = result.data
            this.rec_note = result.data.rec_note
            this.spl_id = result.data.spl_id
            this.supplier =
              result.data.spl_code +
              ' | ' +
              result.data.spl_name +
              ' | ' +
              result.data.spl_plant_code
          } else {
            this.alert_msg('warning', 'Get Receive', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'Get Receive', error.message)
        }
      )
    },
    getSupplier() {
      api.getSuplierReceive(
        this.$store.state.URLHost,
        this.header,
        (result) => {
          if (result.response === true) {
            this.supplier_list = result.data
          } else {
            this.alert_msg('warning', 'An error occurred.', result.message)
          }
        },
        (error) => {
          this.alert_msg('error', 'An error occurred.', error.message)
        }
      )
    },
    addReceiveDetail() {
      this.modal_type = 0
      this.modal_detail = {
        supplier: this.supplier,
        spl_id: this.spl_id,
        rec_id: this.rec_id,
        ps_id: '',
        recd_qty: '',
      }
      this.ModalBoots('ReceiveDetailModal').show()
    },
    editReceiveDetail(obj) {
      this.modal_type = 1
      this.modal_detail_edit = obj
      this.modal_edit_data = {
        supplier: this.supplier,
        partstore:
          obj.pr_id_number + ' | ' + obj.pr_number + ' | ' + obj.pr_name,
      }
      this.ModalBoots('ReceiveDetailModal').show()
    },
    scanSerial(obj) {
      this.modal_type = 2
      this.modal_scan_data.recd_id = obj.recd_id
      this.modal_scan_data.ps_id = obj.ps_id
      if (
        this.modal_scan_data.recd_id !== '' &&
        this.modal_scan_data.recd_id !== undefined
      ) {
        this.ModalBoots('ScanModal').show()
      }
    },
    showReceiveSerial(obj) {
      this.modal_type = 3
      this.modal_receive_detail = obj
      this.ModalBoots('ReceiveSerialModal').show()
    },
    removeReceiveDetail(rs) {
      Swal.fire({
        title: 'Remove Receive Detail',
        text: 'You want to remove this Receive ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#67757c',
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'Cancel',
      }).then((result) => {
        if (result.value) {
          $('.preloader').fadeIn()
          var obj = {
            recd_id: rs.recd_id,
          }
          this.header.params = obj
          api.removeReceiveDetail(
            this.$store.state.URLHost,
            this.header,
            (result) => {
              if (result.response === true) {
                if (this.result_data.pagination.length === 1) {
                  if (this.active_page <= 1) {
                    this.active_page = 1
                  } else {
                    this.active_page--
                  }
                }
                this.search()
                this.alert_msg('success', 'Remove Receive', result.message)
                $('.preloader').fadeOut()
              } else {
                $('.preloader').fadeOut()
                this.search()
                this.alert_msg('warning', 'Remove Receive', result.message)
              }
            },
            (error) => {
              $('.preloader').fadeOut()
              this.alert_msg('error', 'Remove Receive', error.message)
            }
          )
        }
      })
    },
  },
  created() {
    this.checkOAuth()
  },
  mounted() {
    setTimeout(() => {
      this.rec_id =
        this.$route.query.rec_id !== undefined
          ? this.$route.query.rec_id
          : this.rec_id
      if (sessionStorage.token) {
        this.getReceiveByID()
        setTimeout(() => {
          this.activePage(1)
        }, 300)
      } else {
        setTimeout(() => {
          this.getReceiveByID()
          setTimeout(() => {
            this.activePage(1)
          }, 300)
        }, 1000)
      }
    }, 1000)
  },
}



// WEBPACK FOOTER //
// ./src/assets/js/receiveedit.js